<template>
  <div class="page-relative movies-wrapper">
    <MovieBackground :topStyle="style" :botStyle="style"/>
    <!-- 搜索 -->
      <MovieSearch @getCity="getCity" :placeholderText="'搜影片、影院'"></MovieSearch>

    <!-- tab -->
      <div class="acea-row movie-content-tab">
        <span class="page-text-center" v-for='(item,key) in tabList' :key="key" @click="changeTab(item.id)" :class="{onTab:item.id === currentTab}">{{item.title}}</span>
      </div>

      <div class="movie-box movie-content-wrapper">
        <!-- swiper -->
        <div class="movie-content-swiper slider-banner banner">
           <swiper :options="swiperOption" v-if="banner.length > 0">
            <swiper-slide v-for="(item, index) in banner" :key="index">
              <img :src="item.pic" />
            </swiper-slide>
            <div class="swiper-pagination paginationBanner" slot="pagination"></div>
          </swiper>
        </div>


        <!-- list数据 -->
        <div class="movie-content-list">
           <MovieCard :list="moviesList"></MovieCard>
        </div>
      </div>
  </div>
</template>


<script>
import MovieSearch from "@components/MovieSearch";
import MovieCard from "@components/MovieCard"
import { swiper, swiperSlide } from "vue-awesome-swiper";
import MovieBackground from "@components/MovieBackground";


import "@assets/css/swiper.min.css";
let vm = null;

export default {
    name:"Movie",
    components:{
      MovieSearch,
      swiper,
      swiperSlide,
      MovieCard,
      MovieBackground
    },
    data:function(){
      return {
        moviesList:[
          {
            id:0,
            img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
            title:'阿凡达',
            score:'9.3',
            director:'詹姆斯·卡梅隆',
            star:'萨姆·沃辛顿/佐伊·索尔达娜/米歇尔·罗德里格兹'
          },{
            id:1,
            img:'https://image.dongfangfuli.com/2021/01/30/23a9dfdff542d024c050408b9fb11d1f160e9a789e700e61e3e573702a2c54eb1660.jpg',
            title:'你好，李焕英',
            score:'9.2',
            director:'贾玲',
            star:'贾玲/张小斐/沈腾'
          },{
            id:2,
            img:'https://image.dongfangfuli.com/2021/01/04/83f7c2fe6287748d83d3d493a35e98ce784097a2463e74d929fdb46e59720b8e2794.png',
            title:'日不落酒店',
            score:'9.0',
            director:'詹姆斯·卡梅隆',
            star:'萨姆·沃辛顿/佐伊·索尔达娜/米歇尔·罗德里格兹'
          },{
            id:3,
            img:'https://image.dongfangfuli.com/2021/01/30/23a9dfdff542d024c050408b9fb11d1f160e9a789e700e61e3e573702a2c54eb1660.jpg',
            title:'你好，李焕英',
            score:'9.2',
            director:'贾玲',
            star:'贾玲/张小斐/沈腾'
          },{
            id:4,
            img:'https://image.dongfangfuli.com/AdminMovie/image/movie/20210313145835420.jpg',
            title:'阿凡达',
            score:'9.3',
            director:'詹姆斯·卡梅隆',
            star:'萨姆·沃辛顿/佐伊·索尔达娜/米歇尔·罗德里格兹'
          },{
            id:5,
            img:'https://image.dongfangfuli.com/2021/01/30/23a9dfdff542d024c050408b9fb11d1f160e9a789e700e61e3e573702a2c54eb1660.jpg',
            title:'你好，李焕英',
            score:'9.2',
            director:'贾玲',
            star:'贾玲/张小斐/沈腾'
          },{
            id:6,
            img:'https://image.dongfangfuli.com/2021/01/04/83f7c2fe6287748d83d3d493a35e98ce784097a2463e74d929fdb46e59720b8e2794.png',
            title:'日不落酒店',
            score:'9.0',
            director:'詹姆斯·卡梅隆',
            star:'萨姆·沃辛顿/佐伊·索尔达娜/米歇尔·罗德里格兹'
          },
        ],
        //tab切换
        tabList:[{title:'正在热映',id:0},{title:'即将上映',id:1}],
        currentTab: 0,
        style:{
          background:'linear-gradient(-90deg, #FF0B46 0%, #FFAF98 100%)'
        },
        //swiper配置项
        swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        },
        pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets"
        }
      },
      // 测试轮播图模拟数据
      banner:[
        {
          pic:"https://ss1.baidu.com/9vo3dSag_xI4khGko9WTAnF6hhy/zhidao/pic/item/d8f9d72a6059252d659c881e349b033b5bb5b925.jpg",
          url:'/category'
        },{
          pic:"https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fs4.sinaimg.cn%2Fmw690%2F001cPdP6gy6RqawiHqH53%26690&refer=http%3A%2F%2Fs4.sinaimg.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1618729917&t=2af552a7bb3f515fc76e394608e1ea58",
          url:'https://www.baidu.com/'
        },{
          pic:"https://ss1.baidu.com/9vo3dSag_xI4khGko9WTAnF6hhy/zhidao/pic/item/d043ad4bd11373f09bcd975cac0f4bfbfaed0406.jpg",
          url:'https://www.baidu.com/'
        }
      ]
      }
    },
    created() {
      vm = this;
    },
    methods:{
      changeTab:function(val){ //切换tab
        if(val === this.currentTab){
           return;
        }
        this.currentTab = val;
      },

      goUrl(ind){
        let url = this.banner[ind].url;
        let newStr = url.indexOf("http") === 0;
        if (newStr) {
          window.location.href = url;
        } else {
          this.$router.push({
            path: url
          });
        }
      },

      getCity: function(val) {
        console.log('movie-来自搜索组件的城市', val);
      }
    }
}
</script>


<style scoped>
.movie-content-wrapper{
  padding:.1rem .3rem 1rem;
  overflow:hidden;
}
.movie-content-tab{
  width:100%;
  height:.5rem;
  line-height: .5rem;
  padding: 0 .3rem;
}
.movie-content-tab span{
  flex:1;
  color:white;
  font-size:.3rem;
  opacity: .7;
}
.movie-content-tab .onTab{
  font-size:.32rem;
  opacity: 1;
  position: relative;
}
.onTab::after{
  content:'';
  width:1rem;
  height:.02rem;
  background:white;
  position:absolute;
  bottom:0;
  left:36%;
  border-radius:.3rem;
}
.movie-content-swiper{
  width:100%;
  height:3.5rem;
  margin-top:.2rem;
}
.movie-content-swiper img{
  width:100%;
  height:100%;
  border-radius:.3rem;
}
.movie-content-list{
  margin-top:.3rem;
}

</style>

